module.exports = __webpack_public_path__ + "static/media/outsite@2x.8af4012c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/outsite@2x.png
// module id = 1021
// module chunks = 0